module.exports = __webpack_public_path__ + "static/media/mern.d879e7ff.png";